import React from 'react';
import { ComparisonMetrics as ComparisonMetricsType } from '../../../types/comparative';
import MetricCard from '../../ui/MetricCard';
import { 
  ShoppingBagIcon, 
  CheckCircleIcon, 
  XCircleIcon,
  PuzzlePieceIcon
} from '@heroicons/react/24/outline';


interface ComparisonMetricsProps {
  metrics: ComparisonMetricsType | null;
  isLoading?: boolean;
  selectedStore?: string;
}

const ComparisonMetrics: React.FC<ComparisonMetricsProps> = ({ 
  metrics, 
  isLoading = false, selectedStore}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-6 gap- mb-6">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="bg-white rounded-lg shadow-sm p-4 animate-pulse">
            <div className="h-4 bg-gray-200 rounded mb-2"></div>
            <div className="h-8 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  if (!metrics) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
        <div className="text-center text-gray-500">
          <PuzzlePieceIcon className="w-12 h-12 mx-auto mb-2 text-gray-300" />
          <p className="text-lg font-normal">Seleccione una tienda y ejecute la comparación para ver las métricas</p>
        </div>
      </div>
    );
  }

  const formatNumber = (num: number) => {
    return num.toLocaleString('es-CO');
  };

  const formatPercentage = (num: number) => {
    return `${num.toFixed(1)}%`;
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-4 mb-6">
      {/* Total Pedidos Ecommerce */}
      <MetricCard
        title={selectedStore === 'OFIMA' ? 'Pedidos OFIMA' : 'Pedidos Ecommerce'}
        value={formatNumber(metrics.totalEcommerceOrders)}
        icon={<ShoppingBagIcon className="h-7 w-7 text-blue-500" />}
        color="blue"
      />

      {/* Total Pedidos SGL */}
      <MetricCard
        title={selectedStore === 'OFIMA' ? 'Pedidos OFIMA' : 'Pedidos SGL'}
        value={formatNumber(metrics.totalSGLOrders)}
        icon={<ShoppingBagIcon className="h-7 w-7 text-green-500" />}
        color="green"
      />

      {/* Existen en SGL */}
      <MetricCard
        title={selectedStore === 'OFIMA' ? 'Existe en OFIMA' : 'Existe en SGL'}
        value={formatNumber(metrics.synchronizedOrders)}
        icon={<CheckCircleIcon className="h-7 w-7 text-emerald-500" />}
        color="emerald"
      />

      {/* No existen en SGL */}
      <MetricCard
        title={selectedStore === 'OFIMA' ? 'No existe en OFIMA' : 'No existe en SGL'}
        value={formatNumber(metrics.missingInSGL)}
        icon={<XCircleIcon className="h-7 w-7 text-red-500" />}
        color="red"
      />

      {/* Porcentaje de Existencia */}
      <MetricCard
        title={selectedStore === 'OFIMA' ? '% Llegaron a OFIMA' : '% Llegaron a SGL'}
        value={formatPercentage(metrics.syncPercentage)}
        icon={<PuzzlePieceIcon className="h-7 w-7 text-purple-500" />}
        color="purple"
      />

    </div>
  );
};

export default ComparisonMetrics;